<template>
    <div style="text-align: left; background-color: #f5f5f5">
        <div style="margin-bottom: 70px">
            <div class="flex flex-cross-center flex-main-center" style="height: 50vw">
                <img :src="infoData.imgUrlStr" style="height: 33vw"/>
            </div>
            <div style="padding: 15px 15px 15px 15px; background-color: white">
                <div style="font-size: 14px; color: #28405e">{{infoData.combineServiceName}}</div>
                <div style="font-size: 13px; color: #a4afbc; margin-top: 6px">{{infoData.combineServiceTitle}}</div>
                <div style="color: #ff4949; line-height: 23px; margin-top: 10px">
                    <span style="font-size: 15px">￥</span>
                    <span style="font-size: 23px">{{formatMoneyYen(payPrice, 2)}}</span>
                </div>
            </div>
            <van-cell :title="skuName || '请选择规格'" is-link @click.native="showSku = true"/>

            <div style="background-color: white;margin-top: 10px; min-height: 70vh">
                <div v-html="infoData.serviceDetail"></div>
            </div>
        </div>

        <div style="position: fixed; bottom: 0px; left: 0px; right: 0px; background-color: white">
            <div>
                <div style="background-color: #eee; height: 1px"></div>
                <div class="m-l-12 m-r-12 m-b-12">
                    <van-button
                        :disabled="hasBuyPermission != 1 || isIOS"
                        style="width: 100%"
                        :style="{'background-color': hasBuyPermission != 1 ? '#e0e0e0' : '#07affa','color': hasBuyPermission != 1 ? '#666' : '#fff'}"
                        @click.native="showSku = true">{{buyText()}}
                    </van-button>
                </div>
            </div>
        </div>
        <van-popup v-model="showSku" position="bottom" class="van-popup-custom">
            <div style="padding-top: 20px">
                <div style="display: flex; flex-direction: row; background-color:#fff;">
                    <div
                        style="width: 92px; height: 92px; border: #e7ebef 1px solid; border-radius: 5px;  background-color: #fff;position: relative;top:-18px;margin-left: 15px;"
                        class="flex flex-cross-center flex-main-center">
                        <img style="width: 70px; height: 70px" :src="infoData.imgUrlStr">
                    </div>
                    <div style="display: block; padding-left: 15px">
                        <div style="color: #ff4949; line-height: 18px">
                            <span style="font-size: 12px">￥</span>
                            <span
                                style="font-size: 18px">{{formatMoneyYen(payPrice, 2)}}</span>
                        </div>
                        <div style="font-size: 14px; color: #28405e; margin-top: 6px">
                            {{infoData.combineServiceName}}
                        </div>
                    </div>
                </div>
                <div style="background-color: #eee; height: 1px"></div>
                <div style="background-color:#fff; padding: 15px">
                    <div
                        v-if="combineCode == 'MESSAGE_SERVICE' || combineCode == 'STORE_SERVICE' || combineCode == 'CUSTOMER_SERVICE' || combineCode == 'YYZWZ_SERVICE'">
                        <customerSku :paramList="infoData.paramList" :unit="infoData.color"
                                     :combineCode="combineCode" v-on:onPriceChanged="onPriceChanged"></customerSku>
                    </div>
                    <div
                        v-if="combineCode == 'MESSAGE_TYPE_SERVICE'">
                        <smsSku :paramList="infoData.paramList" :unit="infoData.color"
                                v-on:callPriceChanged="callPriceChanged"></smsSku>

                    </div>
                    <div v-if="combineCode == 'CALL_SERVICE'">
                        <callSku :paramList="infoData.paramList" :unit="infoData.color"
                                 v-on:callPriceChanged="callPriceChanged"></callSku>
                    </div>

                    <div v-if="combineCode == 'JMB'">
                        <jmbSku :paramList="infoData.paramList"
                                v-on:callPriceChanged="callPriceChanged"></jmbSku>
                    </div>
                </div>
                <div style="background-color: #eee; height: 1px"></div>
                <div style="background-color: white; padding: 15px">
                    <van-button :disabled="isIOS || hasBuyPermission != 1 || payPrice <= 0"
                                style="color: white; width: 100%; font-size: 15px;"
                                :style="{'background-color': hasBuyPermission != 1 || payPrice <= 0 ? '#e0e0e0' : '#07affa','color': hasBuyPermission != 1 || payPrice <= 0 ? '#666' : '#fff'}"
                                @click="addPay">{{buyText()}}
                    </van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import head from '@/mixins/head';
    import storeOrder from '@/mixins/store-order';
    import customerSku from './va-customer-sku';
    import callSku from './va-call-sku';
    import jmbSku from './va-jmb-sku';
    import smsSku from './va-sms-sku';

    export default {
        name: 'appreciation-service-info',
        components: { customerSku, callSku, jmbSku, smsSku },
        mixins: [head, storeOrder],
        data() {
            return {
                infoData: {
                    buyPrice: 0
                },
                payPrice: 0,
                pickedNumData: {},
                skuName: '',
                pickedCallNumData: [],
                showSku: false,
                count: 1,
                hasBuyPermission: 0,
                isIOS: false
            };
        },
        created() {
            // this.isIOS = /(BD-IOS)/i.test(navigator.userAgent);
            this.isIOS = !/(BD-ANDROID)/i.test(navigator.userAgent);
            if (this.$route.query.combineCode == 'MESSAGE_SERVICE') {
                this.hasBuyPermission = 1;
            } else {
                this.queryAuth();
            }
            this.inited();
            this.queryInfo();
        },
        mounted() {
        },
        watch: {
            '$route': 'inited' // 如果路由有变化，会再次执行该方法
        },
        computed: {
            combineCode() {
                return this.$route.query.combineCode;
            }
        },
        methods: {

            onPriceChanged(data, price, skuName) {
                this.pickedNumData = data;
                this.payPrice = price;
                this.skuName = skuName;
            },

            callPriceChanged(data, price, skuName) {
                console.log('callPriceChanged', data);
                this.pickedCallNumData = data;
                this.payPrice = price;
                this.skuName = skuName;
            },

            buyText() {
                if (this.hasBuyPermission == 1) {
                    if (/(BD-ANDROID)/i.test(navigator.userAgent)) {
                      return '立即购买';
                    }
                    // if (/(BD-IOS)/i.test(navigator.userAgent)) {
                    return '请前往网页端购买';
                    // }
                    // return '立即购买';
                } else if (this.hasBuyPermission == 2) {
                    return '无购买权限';
                }
                return '权限查验中';
            },
            inited() {
                this.setTitle(this.infoData.combineServiceTitle || '详情');
            },
            queryInfo() {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    combineCode: this.$route.query.combineCode
                };
                this.$http.post('badu/BdServiceMarket/queryCombineServiceDetil.do', param).then((response) => {
                    this.$toast.clear();
                    if (response.data) {
                        this.infoData = response.data;
                        this.setTitle(this.infoData.combineServiceName || '详情');
                        if (this.infoData.combineServiceCode == 'JMB') {
                            this.infoData.paramList = this.infoData.paramList.map(m => {
                                return {
                                    ...m,
                                    num: 0
                                };
                            });
                        } else if (this.infoData.combineServiceCode == 'CUSTOMER_SERVICE' ||
                            this.infoData.combineServiceCode == 'STORE_SERVICE' ||
                            this.infoData.combineServiceCode == 'MESSAGE_SERVICE') {
                            // this.numChange(0);
                        }
                    }
                    ;
                }).catch((error) => {
                    this.$toast.clear();
                });
            },

            addPay() {
                // 数量 短信 云盘 客户数
                if (this.combineCode == 'MESSAGE_SERVICE' || this.combineCode == 'STORE_SERVICE' || this.combineCode == 'CUSTOMER_SERVICE' || this.combineCode == 'YYZWZ_SERVICE') {
                    this.setOrderPackage_NUM();
                } else if (this.combineCode == 'CALL_SERVICE') {
                    this.setOrderPackage_CALL();
                } else if (this.combineCode == 'JMB') {
                    this.setOrderPackage_JMB();
                } else if (this.combineCode == 'MESSAGE_TYPE_SERVICE') {
                    this.setOrderPackage_SMS();
                }
            },
            setOrderPackage_NUM() {
                if (!this.pickedNumData.defautValue) {
                    return;
                }
                let A = {
                    combineCode: this.combineCode,
                    // total: 0,
                    total: this.payPrice,
                    number: this.pickedNumData.defautValue,
                    time: 0,
                    productList: [{
                        img: this.infoData.img,
                        combineServiceTitle: this.infoData.combineServiceTitle,
                        tagList: this.infoData.tagList,
                        price: this.number_format(this.payPrice, 2, '.', ',')
                    }],
                    // time: this.diffDay == 0 ? 1 : 0,
                    type: '3_NUM'
                };
                this.pushPayChoose(A);
            },
            setOrderPackage_JMB() {
                console.log('addPay', this.pickedCallNumData);
                if (this.pickedCallNumData && this.pickedCallNumData.length) {
                    console.log('addPay', this.combineCode);
                    let A = {
                        combineCode: this.combineCode,
                        baseCodeList: JSON.stringify(this.pickedCallNumData.map(item => {
                            return {
                                baseCode: item.basicServiceCode,
                                number: item.num
                            };
                        })),
                        productList: [{
                            img: this.infoData.img,
                            combineServiceTitle: this.infoData.combineServiceTitle,
                            tagList: this.infoData.tagList,
                            price: this.number_format(this.payPrice, 2, '.', ',')
                        }],
                        // total: 0,
                        total: this.payPrice,
                        time: 0,
                        // time: this.diffDay == 0 ? 1 : 0,
                        type: '3'
                    };
                    this.pushPayChoose(A);
                }
            },
            setOrderPackage_CALL() {
                if (!this.pickedCallNumData || !this.pickedCallNumData.length) {
                    return;
                }
                let A = {
                    // total: 0,
                    total: this.payPrice,
                    time: 0,
                    productList: [{
                        img: this.infoData.img,
                        combineServiceTitle: this.infoData.combineServiceTitle,
                        tagList: this.infoData.tagList,
                        price: this.number_format(this.payPrice, 2, '.', ',')
                    }],
                    // time: this.diffDay == 0 ? 1 : 0,
                    type: '3_CALL'
                };
                this.pickedCallNumData.map(item => {
                    if (item.basicServiceCode == 'CALL_1') {
                        A['call_service_1'] = item.defautValue;
                    }
                    if (item.basicServiceCode == 'CALL_2') {
                        A['call_service_2'] = item.defautValue;
                    }
                });
                this.pushPayChoose(A);
            },
            setOrderPackage_SMS() {
                if (!this.pickedCallNumData || !this.pickedCallNumData.length) {
                    return;
                }
                let A = {
                    // total: 0,
                    total: this.payPrice,
                    time: 0,
                    productList: [{
                        img: this.infoData.img,
                        combineServiceTitle: this.infoData.combineServiceTitle,
                        tagList: this.infoData.tagList,
                        price: this.number_format(this.payPrice, 2, '.', ',')
                    }],
                    // time: this.diffDay == 0 ? 1 : 0,
                    type: '3_MES'
                };
                this.pickedCallNumData.map(item => {
                    A[item.basicServiceCode] = item.defautValue;
                });
                this.pushPayChoose(A);
            },
            pushPayChoose(A) {
                // if (A.total <= 0) {
                //     return;
                // }
                this.$storage.set('STORE_ORDER_PACKAGE', A);
                setTimeout(() => {
                    this.PUSH({ name: 'store-pay-preview' });
                }, 200);
            },

            number_format(number, decimals, decPoint, thousandsSep) {
                /*
                * 参数说明：
                * number：要格式化的数字
                * decimals：保留几位小数
                * dec_point：小数点符号
                * thousands_sep：千分位符号
                * */
                number = (number + '').replace(/[^0-9+-Ee.]/g, '');
                var n = !isFinite(+number) ? 0 : +number;
                var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
                var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep;
                var dec = (typeof decPoint === 'undefined') ? '.' : decPoint;
                var s = '';
                var toFixedFix = function (n, prec) {
                    var k = Math.pow(10, prec);
                    return '' + Math.ceil(n * k) / k;
                };

                s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
                var re = /(-?\d+)(\d{3})/;
                while (re.test(s[0])) {
                    s[0] = s[0].replace(re, '$1' + sep + '$2');
                }

                if ((s[1] || '').length < prec) {
                    s[1] = s[1] || '';
                    s[1] += new Array(prec - s[1].length + 1).join('0');
                }
                return s.join(dec);
            },

            queryAuth() {
                let param = {};
                this.$http.post('profile/getUserBaseInfo.do', param).then((response) => {
                    if (response.data) {
                        if (response.data.authList.indexOf('BUY_APP') >= 0) {
                            this.hasBuyPermission = 1;
                        } else {
                            this.hasBuyPermission = 2;
                        }
                    }
                }).catch(() => {
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .van-popup-custom {
        background-color: transparent;
    }

    .van-stepper__input {
        width: 80px;
    }

    .jmb-item {
        width: 223px;
        float: left;
        .hover-shadow {
            border: 1px solid #409EFF;
            border-radius: 0;
        }

        &:nth-child(2n-1) {
            margin-right: 10px;
        }

        .select--sku {
            margin: -1px;
            box-sizing: border-box;
            width: calc(100% + 2px);
        }
    }
</style>
